import React, { useEffect, useState, useRef } from "react";
import "../../styles/desktop/CampoLuzes.css";
import { LightGroup } from "../Classes/LightGroup";
import Ligado from "../../assets/img/Ligado.png";
import Desligado from "../../assets/img/Desligado.png";
import { getLuzesStatusFlex35, statusDasLuzesFlex35 } from "../../API/FeedBackLuzes";

const GroupLightComponent = () => {

  const groupRefs = useRef({
    grupo06: React.createRef(),
    grupo07: React.createRef(),
    grupo08: React.createRef(),
    grupo09: React.createRef(),
    grupo10: React.createRef(),
    grupo11: React.createRef(),
    grupo12: React.createRef(),
    grupo13: React.createRef(),
    grupo14: React.createRef(),
    grupo17: React.createRef(),
    grupo18: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo06: false,
    grupo07: false,
    grupo08: false,
    grupo09: false,
    grupo10: false,
    grupo11: false,
    grupo12: false,
    grupo13: false,
    grupo14: false,
    grupo17: false,
    grupo18: false,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      updateLightGroup();
      console.log(`Status das luzes: ${statusDasLuzesFlex35}`);
      setLoading(false);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 3000);
  
    return () => clearInterval(intervalId);
  }, []);

  const updateLightGroup = () => {
    setImageStates({
      grupo06: statusDasLuzesFlex35.includes("1A10") && !statusDasLuzesFlex35.includes("1A00"),
      grupo07: statusDasLuzesFlex35.includes("1B10") && !statusDasLuzesFlex35.includes("1B00"),
      grupo08: statusDasLuzesFlex35.includes("1F10") && !statusDasLuzesFlex35.includes("1F00"),
      grupo09: statusDasLuzesFlex35.includes("1M10") && !statusDasLuzesFlex35.includes("1M00"),
      grupo10: statusDasLuzesFlex35.includes("1L10") && !statusDasLuzesFlex35.includes("1L00"),
      grupo11: statusDasLuzesFlex35.includes("1O10") && !statusDasLuzesFlex35.includes("1O00"),
      grupo12: statusDasLuzesFlex35.includes("1N10") && !statusDasLuzesFlex35.includes("1N00"),
      grupo13: statusDasLuzesFlex35.includes("1J10") && !statusDasLuzesFlex35.includes("1J00"),
      grupo14: statusDasLuzesFlex35.includes("1K10") && !statusDasLuzesFlex35.includes("1K00"),
      grupo17: statusDasLuzesFlex35.includes("1P10") && !statusDasLuzesFlex35.includes("1P00"),
      grupo18: statusDasLuzesFlex35.includes("1G10") && !statusDasLuzesFlex35.includes("1G00"),
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <>
      <div className="group" id="campoGroup-pagina3">
          
          {/* Grupo 6 */}
  
          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo06}
            groupId="grupo06"
            descricao="Quadra 1"
            imageUrl={imageStates.grupo06 ? Ligado : Desligado}
            onCommand="1A10"
            offCommand="1A00"
            onToggle={handleToggleLightGroup}
            x={60.8}
            y={60.4}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo06}
            onToggleLightGroup={handleToggleLightGroup}

          />

          {/* Grupo 7 */}

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo07}
            groupId="grupo07"
            descricao="Quadra 2"
            imageUrl={imageStates.grupo07? Ligado : Desligado}
            onCommand="1B10"
            offCommand="1B00"
            onToggle={handleToggleLightGroup}
            x={71.1}
            y={60.1}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo07}
            onToggleLightGroup={handleToggleLightGroup}
          />

          {/* Grupo 8 */}

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo08}
            groupId="grupo08"
            descricao="Pergolado"
            imageUrl={imageStates.grupo08? Ligado : Desligado}
            onCommand="1F10"
            offCommand="1F00"
            onToggle={handleToggleLightGroup}
            x={47.5}
            y={84.7}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo08}
            onToggleLightGroup={handleToggleLightGroup}
          />
          
          {/* Grupo 9 */}

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo09}
            groupId="grupo09"
            descricao="Piscina Grande"
            imageUrl={imageStates.grupo09? Ligado : Desligado}
            onCommand="1M10"
            offCommand="1M00"
            onToggle={handleToggleLightGroup}
            x={54.3}
            y={60.5}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo09}
            onToggleLightGroup={handleToggleLightGroup}
          />
          
          {/* Grupo 10 */}

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo10}
            groupId="grupo10"
            descricao="Piscina Infantil"
            imageUrl={imageStates.grupo10? Ligado : Desligado}
            onCommand="1L10"
            offCommand="1L00"
            onToggle={handleToggleLightGroup}
            x={47.5}
            y={45}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo10}
            onToggleLightGroup={handleToggleLightGroup}
          />
          
          {/* Grupo 11 */}

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo11}
            groupId="grupo11"
            descricao="Floreira Entrada Piscina"
            imageUrl={imageStates.grupo11? Ligado : Desligado}
            onCommand="1O10"
            offCommand="1O00"
            onToggle={handleToggleLightGroup}
            x={43}
            y={43.7}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo11}
            onToggleLightGroup={handleToggleLightGroup}
          />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo11}
          groupId="grupo11"
          descricao="Floreira Entrada Piscina"
          imageUrl={imageStates.grupo11? Ligado : Desligado}
          onCommand="1O10"
          offCommand="1O00"
          onToggle={handleToggleLightGroup}
          x={43}
          y={73}
          width={2.9}
          height={4.5}
          imageState={imageStates.grupo11}
          onToggleLightGroup={handleToggleLightGroup}
        />

          
          {/* Grupo 12 */}

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo12}
            groupId="grupo12"
            descricao="Escada Poste"
            imageUrl={imageStates.grupo12? Ligado : Desligado}
            onCommand="1N10"
            offCommand="1N00"
            onToggle={handleToggleLightGroup}
            x={43}
            y={55}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo12}
            onToggleLightGroup={handleToggleLightGroup}
          />

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo12}
            groupId="grupo12"
            descricao="Escada Poste"
            imageUrl={imageStates.grupo12? Ligado : Desligado}
            onCommand="1N10"
            offCommand="1N00"
            onToggle={handleToggleLightGroup}
            x={47.5}
            y={54}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo12}
            onToggleLightGroup={handleToggleLightGroup}
          />

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo12}
            groupId="grupo12"
            descricao="Escada Poste"
            imageUrl={imageStates.grupo12? Ligado : Desligado}
            onCommand="1N10"
            offCommand="1N00"
            onToggle={handleToggleLightGroup}
            x={47.55}
            y={75}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo12}
            onToggleLightGroup={handleToggleLightGroup}
          />

          {/* Grupo 13 */}

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo13}
            groupId="grupo13"
            descricao="Floreira Muro e Garden Gourmet"
            imageUrl={imageStates.grupo13? Ligado : Desligado}
            onCommand="1J10"
            offCommand="1J00"
            onToggle={handleToggleLightGroup}
            x={45.3}
            y={30.5}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo13}
            onToggleLightGroup={handleToggleLightGroup}
          />

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo13}
            groupId="grupo13"
            descricao="Floreira Muro e Garden Gourmet"
            imageUrl={imageStates.grupo13? Ligado : Desligado}
            onCommand="1J10"
            offCommand="1J00"
            onToggle={handleToggleLightGroup}
            x={52.35}
            y={30.5}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo13}
            onToggleLightGroup={handleToggleLightGroup}
          />

          {/* Grupo 14 */}

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo14}
            groupId="grupo14"
            descricao="Floreira Espaço Kids"
            imageUrl={imageStates.grupo14? Ligado : Desligado}
            onCommand="1K10"
            offCommand="1K00"
            onToggle={handleToggleLightGroup}
            x={32.35}
            y={24}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo14}
            onToggleLightGroup={handleToggleLightGroup}
          />

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo14}
            groupId="grupo14"
            descricao="Floreira Espaço Kids"
            imageUrl={imageStates.grupo14? Ligado : Desligado}
            onCommand="1K10"
            offCommand="1K00"
            onToggle={handleToggleLightGroup}
            x={38.2}
            y={37}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo14}
            onToggleLightGroup={handleToggleLightGroup}
          />

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo14}
            groupId="grupo14"
            descricao="Floreira Espaço Kids"
            imageUrl={imageStates.grupo14? Ligado : Desligado}
            onCommand="1K10"
            offCommand="1K00"
            onToggle={handleToggleLightGroup}
            x={33.1}
            y={37.4}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo14}
            onToggleLightGroup={handleToggleLightGroup}
          />

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo14}
            groupId="grupo14"
            descricao="Floreira Espaço Kids"
            imageUrl={imageStates.grupo14? Ligado : Desligado}
            onCommand="1K10"
            offCommand="1K00"
            onToggle={handleToggleLightGroup}
            x={28.65}
            y={37.5}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo14}
            onToggleLightGroup={handleToggleLightGroup}
          />

          {/* Grupo 17 */}

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo17}
            groupId="grupo17"
            descricao="Hall Elevador + Varanda"
            imageUrl={imageStates.grupo17? Ligado : Desligado}
            onCommand="1P10"
            offCommand="1P00"
            onToggle={handleToggleLightGroup}
            x={28.7}
            y={27}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo17}
            onToggleLightGroup={handleToggleLightGroup}
          />

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo17}
            groupId="grupo17"
            descricao="Hall Elevador + Varanda"
            imageUrl={imageStates.grupo17? Ligado : Desligado}
            onCommand="1P10"
            offCommand="1P00"
            onToggle={handleToggleLightGroup}
            x={37.9}
            y={63}
            width={2.6}
            height={26.5}
            imageState={imageStates.grupo17}
            onToggleLightGroup={handleToggleLightGroup}
          />

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo17}
            groupId="grupo17"
            descricao="Hall Elevador + Varanda"
            imageUrl={imageStates.grupo17? Ligado : Desligado}
            onCommand="1P10"
            offCommand="1P00"
            onToggle={handleToggleLightGroup}
            x={29.1}
            y={57}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo17}
            onToggleLightGroup={handleToggleLightGroup}
          />

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo17}
            groupId="grupo17"
            descricao="Hall Elevador + Varanda"
            imageUrl={imageStates.grupo17? Ligado : Desligado}
            onCommand="1P10"
            offCommand="1P00"
            onToggle={handleToggleLightGroup}
            x={14.5}
            y={57.2}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo17}
            onToggleLightGroup={handleToggleLightGroup}
          />

          {/* Grupo 18 */}

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo18}
            groupId="grupo18"
            descricao="Muro Piscina"
            imageUrl={imageStates.grupo18? Ligado : Desligado}
            onCommand="1G10"
            offCommand="1G00"
            onToggle={handleToggleLightGroup}
            x={61.5}
            y={75.8}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo18}
            onToggleLightGroup={handleToggleLightGroup}
          />

          <LightGroup
            className="light_button"
            ref={groupRefs.current.grupo18}
            groupId="grupo18"
            descricao="Muro Piscina"
            imageUrl={imageStates.grupo18? Ligado : Desligado}
            onCommand="1G10"
            offCommand="1G00"
            onToggle={handleToggleLightGroup}
            x={59.35}
            y={48.3}
            width={2.9}
            height={4.5}
            imageState={imageStates.grupo18}
            onToggleLightGroup={handleToggleLightGroup}
          />

          {/* Legenda de acionamentos */}

          <div id="campo-clickable-element-lazer2" className="campo-clickable-element">
            <div
              id="clickable-element"
              className="clickable-element"
              onClick={() => {
                handleToggleLightGroup('grupo06', !imageStates.grupo06);
                groupRefs.current.grupo06.current.sendCommand(
                  groupRefs.current.grupo06.current.props.descricao,
                  imageStates.grupo06 ? groupRefs.current.grupo06.current.props.offCommand : groupRefs.current.grupo06.current.props.onCommand
                );
              }}
            >
              <p className={`NumberTextBar${imageStates.grupo06 ? 'Highlighted' : ''}`}>6</p>
              <p className="textBar">Quadra 1</p>
            </div>
            <div
            id="clickable-element"
            className="clickable-element"
            onClick={() => {
              handleToggleLightGroup('grupo07', !imageStates.grupo07);
              groupRefs.current.grupo07.current.sendCommand(
                groupRefs.current.grupo07.current.props.descricao,
                imageStates.grupo07 ? groupRefs.current.grupo07.current.props.offCommand : groupRefs.current.grupo07.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo07? 'Highlighted' : ''}`}>7</p>
            <p className="textBar">Quadra 2</p>
          </div>
          <div
            id="clickable-element"
            className="clickable-element"
            onClick={() => {
              handleToggleLightGroup('grupo08', !imageStates.grupo08);
              groupRefs.current.grupo08.current.sendCommand(
                groupRefs.current.grupo08.current.props.descricao,
                imageStates.grupo08 ? groupRefs.current.grupo08.current.props.offCommand : groupRefs.current.grupo08.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo08? 'Highlighted' : ''}`}>8</p>
            <p className="textBar">Pergolado</p>
          </div>
          <div
            id="clickable-element"
            className="clickable-element"
            onClick={() => {
              handleToggleLightGroup('grupo09', !imageStates.grupo09);
              groupRefs.current.grupo09.current.sendCommand(
                groupRefs.current.grupo09.current.props.descricao,
                imageStates.grupo09 ? groupRefs.current.grupo09.current.props.offCommand : groupRefs.current.grupo09.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo09? 'Highlighted' : ''}`}>9</p>
            <p className="textBar">Piscina</p>
          </div>
          <div
            id="clickable-element"
            className="clickable-element"
            onClick={() => {
              handleToggleLightGroup('grupo10', !imageStates.grupo10);
              groupRefs.current.grupo10.current.sendCommand(
                groupRefs.current.grupo10.current.props.descricao,
                imageStates.grupo10 ? groupRefs.current.grupo10.current.props.offCommand : groupRefs.current.grupo10.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo10? 'Highlighted' : ''}`}>10</p>
            <p className="textBar">Piscina Infantil</p>
          </div>
          <div
            id="clickable-element"
            className="clickable-element"
            onClick={() => {
              handleToggleLightGroup('grupo11', !imageStates.grupo11);
              groupRefs.current.grupo11.current.sendCommand(
                groupRefs.current.grupo11.current.props.descricao,
                imageStates.grupo11 ? groupRefs.current.grupo11.current.props.offCommand : groupRefs.current.grupo11.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo11? 'Highlighted' : ''}`}>11</p>
            <p className="textBar">Floreira Piscina</p>
          </div>
          <div
            id="clickable-element"
            className="clickable-element"
            onClick={() => {
              handleToggleLightGroup('grupo12', !imageStates.grupo12);
              groupRefs.current.grupo12.current.sendCommand(
                groupRefs.current.grupo12.current.props.descricao,
                imageStates.grupo12 ? groupRefs.current.grupo12.current.props.offCommand : groupRefs.current.grupo12.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo12? 'Highlighted' : ''}`}>12</p>
            <p className="textBar">Escada Poste</p>
          </div>
          <div
            id="clickable-element"
            className="clickable-element"
            onClick={() => {
              handleToggleLightGroup('grupo13', !imageStates.grupo13);
              groupRefs.current.grupo13.current.sendCommand(
                groupRefs.current.grupo13.current.props.descricao,
                imageStates.grupo13 ? groupRefs.current.grupo13.current.props.offCommand : groupRefs.current.grupo13.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo13? 'Highlighted' : ''}`}>13</p>
            <p className="textBar">Floreira + Garden Gourmet</p>
          </div>
          <div
            id="clickable-element"
            className="clickable-element"
            onClick={() => {
              handleToggleLightGroup('grupo14', !imageStates.grupo14);
              groupRefs.current.grupo14.current.sendCommand(
                groupRefs.current.grupo14.current.props.descricao,
                imageStates.grupo14 ? groupRefs.current.grupo14.current.props.offCommand : groupRefs.current.grupo14.current.props.onCommand
              );
            }}
          >
            <p className={`NumberTextBar${imageStates.grupo14? 'Highlighted' : ''}`}>14</p>
            <p className="textBar">Floreira + Espaço Kids</p>
          </div>
          <div
            id="clickable-element"
            className="clickable-element"
            onClick={() => {
              handleToggleLightGroup('grupo17', !imageStates.grupo17);
              groupRefs.current.grupo17.current.sendCommand(
                groupRefs.current.grupo17.current.props.descricao,
                imageStates.grupo17 ? groupRefs.current.grupo17.current.props.offCommand : groupRefs.current.grupo17.current.props.onCommand
              );
            }}
            > 
              <p className={`NumberTextBar${imageStates.grupo17? 'Highlighted' : ''}`}>17</p>
              <p className="textBar">Hall Elevador + Varanda</p>
            </div>
            <div
              id="clickable-element"
              className="clickable-element-last"
              onClick={() => {
                handleToggleLightGroup('grupo18', !imageStates.grupo18);
                groupRefs.current.grupo18.current.sendCommand(
                  groupRefs.current.grupo18.current.props.descricao,
                  imageStates.grupo18 ? groupRefs.current.grupo18.current.props.offCommand : groupRefs.current.grupo18.current.props.onCommand
                );
              }}
              >
                <p className={`NumberTextBar${imageStates.grupo18? 'Highlighted' : ''}`}>18</p>
                <p className="textBar">Muro da Piscina </p>
              </div>
        </div>
      </div>
    </>
  );
  
}


export default GroupLightComponent;
